import React, { createContext, useContext, useState, ReactNode } from "react";

interface RequestTypeContextProps {
  requestTypeDetails: any | null;
  setRequestTypeDetails: (details: any) => void;
}

const RequestTypeContext = createContext<RequestTypeContextProps | undefined>(undefined);

export const RequestTypeProvider = ({ children }: { children: ReactNode }) => {

  const [requestTypeDetails, setRequestTypeDetails] = useState<any>(null);

  return (
    <RequestTypeContext.Provider value={{ requestTypeDetails, setRequestTypeDetails }}>
      {children}
    </RequestTypeContext.Provider>
  );
};

export const useRequestType = () => {
  const context = useContext(RequestTypeContext);
  if (!context) {
    throw new Error("useRequestType must be used within a RequestTypeProvider");
  }
  return context;
};